import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-video-allocated.component.ajs.html';

const MODULE_NAME = 'agentBookingVideoAllocated';

class AgentBookingVideoAllocatedCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingVideoAllocated implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingVideoAllocatedCtrl];
}

export default MODULE_NAME;
